/*
 * @ Author: wangjiyu
 * @Date: 2019-11-13 09:36:50
 * @LastEditTime: 2020-05-07 16:35:49
 * @LastEditors: wangjiyu
 * @Description: file content
 */

import { IPostItem, ITopic, ILocation, ISetControlIcon } from '../interface';
import ActionType from './ActionType';

function setCover(cover: string) {
    return {
        type: ActionType.PostSetCover,
        payload: {
            cover,
        },
    };
}
function setCoverPixel(coverPixel: string) {
    return {
        type: ActionType.PostSetCoverPixel,
        payload: {
            coverPixel,
        },
    };
}
function setTitle(title: string) {
    return {
        type: ActionType.PostSetTitle,
        payload: {
            title,
        },
    };
}
function setValidAtMax(validAtMax: string) {
    return {
        type: ActionType.PostValidAtMax,
        payload: {
            validAtMax,
        },
    };
}

function setValidAtMin(validAtMin: string) {
    return {
        type: ActionType.PostValidAtMin,
        payload: {
            validAtMin,
        },
    };
}
function setProductId(productId: string) {
    return {
        type: ActionType.PostSetProductId,
        payload: {
            productId,
        },
    };
}

function setTopic(topic: ITopic) {
    return {
        type: ActionType.PostSetTopic,
        payload: {
            topic,
        },
    };
}

function setLocation(location: ILocation) {
    return {
        type: ActionType.PostSetLocation,
        payload: {
            location,
        },
    };
}
function setMusic(music: { title: string; url: string }) {
    return {
        type: ActionType.PostSetMusic,
        payload: {
            music,
        },
    };
}
function delMusic() {
    return {
        type: ActionType.PostDeleteMusic,
    };
}
function togglePlay() {
    return {
        type: ActionType.PostSetHasPlay,
    };
}
function setContent(content: IPostItem[]) {
    return {
        type: ActionType.PostSetContent,
        payload: content,
    };
}
function setVoteListBottom(index: number, item: IPostItem) {
    return {
        type: ActionType.setVoteListBottom,
        payload: {
            index,
            item,
        },
    };
}
function setVoteListTop(index: number, item: IPostItem) {
    return {
        type: ActionType.setVoteListTop,
        payload: {
            index,
            item,
        },
    };
}

function setContentByIndex(index: number, item: IPostItem) {
    return {
        type: ActionType.PostSetContentByIndex,
        payload: {
            index,
            item,
        },
    };
}
function insertContentByIndex(index: number, item: IPostItem) {
    return {
        type: ActionType.PostInsertContentByIndex,
        payload: {
            index,
            item,
        },
    };
}
function insertTitleByIndex(index: number, item: IPostItem) {
    return {
        type: ActionType.PostInsertTitleByIndex,
        payload: {
            index,
            item,
        },
    };
}
function editTitleByIndex(index: number, item: IPostItem) {
    return {
        type: ActionType.PostEditTitleByIndex,
        payload: {
            index,
            item,
        },
    };
}
function removeContentByIndex(index: number) {
    return {
        type: ActionType.PostRemoveContentByIndex,
        payload: {
            index,
        },
    };
}
function setCurrentInputIndex(currentInputIndex: number) {
    return {
        type: ActionType.PostSetCurrentInputIndex,
        payload: {
            currentInputIndex,
        },
    };
}
function setCurrentIndex(currentIndex: number) {
    return {
        type: ActionType.PostSetCurrentIndex,
        payload: {
            currentIndex,
        },
    };
}
function setCurrentTarget(currentTarget: React.ReactInstance) {
    return {
        type: ActionType.PostSetCurrentTarget,
        payload: {
            currentTarget,
        },
    };
}
function setHasFocusTitle(hasFocusTitle: boolean) {
    return {
        type: ActionType.PostSetHasFocusTitle,
        payload: {
            hasFocusTitle,
        },
    };
}
// 设置首页文章内容滚动条高度
function setMainScrollTop(scrollTo: number) {
    return {
        type: ActionType.PostSetMainScrollTop,
        payload: {
            scrollTo,
        },
    };
}
// 设置keyboradheight
function setKeyboradHeight(keyboradHeight: number) {
    return {
        type: ActionType.setKeyboradHeight,
        payload: {
            keyboradHeight,
        },
    };
}
// 设置emoji显示状态
function setEmojiVisible(emojiVisible: boolean) {
    return {
        type: ActionType.setEmojiVisible,
        payload: {
            emojiVisible,
        },
    };
}
// 设置emoji框高度
function setEmojiBoxHeight(emojiBoxHeight: number) {
    return {
        type: ActionType.setEmojiBoxHeight,
        payload: {
            emojiBoxHeight,
        },
    };
}

function setEmptyViewHeight(height: number) {
    return {
        type: ActionType.setEmptyViewHeight,
        payload: {
            emptyViewHeight: height,
        },
    };
}
function setSelectionEnd(selectionEnd: number) {
    return {
        type: ActionType.setSelectionEnd,
        payload: {
            selectionEnd,
        },
    };
}
function setHasInputEmoji(hasInputEmoji: boolean) {
    // 设置是否正在输入emoji状态
    return {
        type: ActionType.setHasInputEmoji,
        payload: {
            hasInputEmoji,
        },
    };
}
function setMaxFile(maxFile: number) {
    return {
        type: ActionType.setMaxFile,
        payload: {
            maxFile,
        },
    };
}
function setMaxVideo(maxVideo: number) {
    return {
        type: ActionType.setMaxVideo,
        payload: {
            maxVideo,
        },
    };
}
// 控制栏icon是否可以
function setControlIconActive(controlIconActive: ISetControlIcon) {
    return {
        type: ActionType.setControlIconActive,
        payload: {
            controlIconActive,
        },
    };
}
function setGroupId(groupId: string) {
    return {
        type: ActionType.PostGroupId,
        payload: {
            groupId,
        },
    };
}
export default {
    setCover,
    setTitle,
    setValidAtMax,
    setValidAtMin,
    setMusic,
    setContent,
    setVoteListTop,
    setVoteListBottom,
    setContentByIndex,
    setCurrentInputIndex,
    setCurrentIndex,
    setCurrentTarget,
    insertContentByIndex,
    insertTitleByIndex,
    editTitleByIndex,
    removeContentByIndex,
    setMainScrollTop,
    setHasFocusTitle,
    delMusic,
    togglePlay,
    setKeyboradHeight, // 设置keyboradheight
    setEmojiVisible,
    setEmojiBoxHeight,
    setEmptyViewHeight,
    setSelectionEnd,
    setHasInputEmoji,
    setMaxFile,
    setMaxVideo,
    setProductId,
    setLocation,
    setTopic,
    setControlIconActive,
    setCoverPixel,
    setGroupId,
};
